import { gql } from "@outschool/ui-apollo";

export const meetingReviewMutation = gql`
  mutation MeetingReviewMutationForParent(
    $sectionUid: ID!
    $rating: Int!
    $type: MeetingReviewType!
    $learnerUid: ID!
  ) {
    createMeetingReview(
      sectionUid: $sectionUid
      rating: $rating
      type: $type
      learnerUid: $learnerUid
    ) {
      uid
      learnerUid
      rating
      meetingUid
      sectionUid
    }
  }
`;
